/* eslint-disable camelcase */
/* eslint-disable dot-notation */
import ApiService from './ApiService'

export default class UserService {
    apiService

    constructor(token) {
        this.apiService = new ApiService(process.env.VUE_APP_AUTH_API)

        this.apiService.setAccessToken(token)
    }

    get({ company_uuid, cc, lang }) {
        return this.apiService
            .setAcceptLanguage(`${lang}-${cc}`)
            .get(`/${company_uuid}/account`)
    }

    async otpVerify({ company_uuid, user_uuid }) {
        return this.apiService.patch(`/${company_uuid}/users/${user_uuid}/telcos/safaricom/otp/verified`)
    }
}
